export default __webpack_public_path__ + "static/media/KHAH5Z2K3FBRHDQTPX4UVPVK3Q 1.4ff360cc.png";